module.exports = __webpack_public_path__ + "media/common/icons/credit_card-fe36413f2029244df1573db0a8862888.svg";